import React from 'react'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import bodyScrollLock from '../global/js/bodyScrollLockHandler'
import breakpoints from '../global/js/breakpoints'
import Footer from '../components/footer'
import Header from '../components/header'
import Nav from '../components/nav'
import PrimarySquareCard from '../components/primary-square-card'
import TerciaryHorizontalCard from '../components/terciary-horizontal-card'

class CompanyPage extends React.Component {
  constructor () {
    super()
    this.state = {
      stripeId: null,
      cardId: null,
      company: null,
      groupSize: 4,
      companies: null
    }
    this.subdivideCompanies = this.subdivideCompanies.bind(this)
    this.subdivideArray = this.subdivideArray.bind(this)
    this.generateLogoLayouts = this.generateLogoLayouts.bind(this)
    this.generateLogoLayout = this.generateLogoLayout.bind(this)
    this.selectLogo = this.selectLogo.bind(this)
    this.windowSizeListener = this.windowSizeListener.bind(this)
    this.setGroupSize = this.setGroupSize.bind(this)
    this.closeMobileMenu = this.closeMobileMenu.bind(this)
  }

  subdivideCompanies (companies) {
    var copyOfCompanies = Array.from(companies)
    return this.subdivideArray(this.state.groupSize, copyOfCompanies)
  }

  subdivideArray (size, a) {
    var arrays = []
    while (a.length > 0) {
      arrays.push(a.splice(0, size))
    }
    return arrays
  }

  generateLogoLayouts (companyGroups) {
    return (
      companyGroups.map((companies, i) => {
        return this.generateLogoLayout(companies, i)
      })
    )
  }

  generateLogoLayout (companies, index) {
    return (
      <div key={index}>
        <div className='container' key={index}>
          <div className='grid'>
            {companies.map((company, i) => {
              let isActive
              if (this.state.stripeId === index && this.state.cardId === i) {
                isActive = true
              }

              return (
                <div className='grid-1of4 grid-1of3--portable grid-1of2--ipad' onClick={() => this.selectLogo({stripeId: index, cardId: i, company: company})} key={i}>
                  <PrimarySquareCard isActive={isActive} logo={company.companyLogo} />
                </div>
              )
            })}
          </div>
        </div>
        <ReactCSSTransitionGroup
          transitionName='example'>
          {this.state.stripeId === index ? <TerciaryHorizontalCard data={this.state.company} closeMobileMenu={this.closeMobileMenu} key={index + '-terciary-horizontal-card'} /> : ''}
        </ReactCSSTransitionGroup>
      </div>
    )
  }

  closeMobileMenu () {
    this.setState({stripeId: null, cardId: null})
    bodyScrollLock(false)
  }

  selectLogo ({stripeId, cardId, company}) {
    if (stripeId === this.state.stripeId && cardId === this.state.cardId) {
      this.setState({stripeId: null})
    } else {
      this.setState({stripeId, cardId})
    }
    this.setState({company})
    this.mobileBodyScrollLock()
  }

  mobileBodyScrollLock () {
    if (typeof window === 'undefined' || window.innerWidth > 600) {
      bodyScrollLock(false)
    } else if (this.state.stripeId) {
      bodyScrollLock(true)
    }
  }

  windowSizeListener () {
    if (typeof window === 'undefined') return
    window.onresize = e => this.setGroupSize(e.target.innerWidth)
  }

  setGroupSize (windowWidth) {
    let groupSize = 2
    breakpoints.some((breakpoint) => {
      if (windowWidth > breakpoint.width) {
        groupSize = breakpoint.groupSize
        return true
      }
    })
    this.setState({groupSize})
  }

  componentWillMount () {
    this.setState({companies: this.props.data.contentfulPage.companiesCompanyProfiles})
    this.windowSizeListener()
    if (typeof window === 'undefined') return
    this.setGroupSize(window.innerWidth)
  }

  render () {
    this.mobileBodyScrollLock()
    const page = this.props.data.contentfulPage
    const headerTitle = md.renderInline(page.headerTitle.headerTitle)
    const footer = {
      footerCatchphrase: page.footerCatchphrase.footerCatchphrase,
      footerNav: page.footerNav
    }
    const companyGroups = this.subdivideCompanies(this.state.companies)
    return (
      <div>
        <Nav data={page.navigationBar} />
        <Header
          navItems={page.navigationBar}
          template='secondary'
          bgImage={page.headerBackground.file.url}
          headingText={headerTitle}
          subheadingText={page.headerSubtitle}
        />
        <div className='u-paddingTopLarge'>
          {this.generateLogoLayouts(companyGroups)}
        </div>
        <Footer data={footer} secondary />
      </div>
    )
  }
}

export const pageQuery = graphql`
  query CompaniesQuery {
    contentfulPage(pageName: {eq: "Companies"}) {
      id
      navigationBar {
        id
        navigationItems {
          id
          pageName
        }
      }
      headerTitle {
        headerTitle
      }
      headerBackground {
        id
        file {
          url
          fileName
          contentType
        }
      }
      headerSubtitle
      companiesCompanyProfiles {
        id
        companyName
        companyWebsiteUrl
        companySideList1
        companyLogo {
          file {
            url
          }
        }
        companyDescription {
          id
          companyDescription
        }
      }
      footerCatchphrase {
        id
        footerCatchphrase
      }
      footerNav {
        id
        footerCopyrights
        footerAddress
      }
    }
  }
`

export default CompanyPage



// WEBPACK FOOTER //
// ./src/pages/companies.js